var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneiphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone iphone",
    clipPath: "url(#clip0_71_24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.625 0.75H5.625C4.59 0.75 3.75 1.59 3.75 2.625V15.375C3.75 16.41 4.59 17.25 5.625 17.25H11.625C12.66 17.25 13.5 16.41 13.5 15.375V2.625C13.5 1.59 12.66 0.75 11.625 0.75ZM8.625 16.5C8.0025 16.5 7.5 15.9975 7.5 15.375C7.5 14.7525 8.0025 14.25 8.625 14.25C9.2475 14.25 9.75 14.7525 9.75 15.375C9.75 15.9975 9.2475 16.5 8.625 16.5ZM12 13.5H5.25V3H12V13.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneiphone);
export default __webpack_public_path__ + "static/media/Phone iphone.7c401f91baf41e658979c110cba5d2a4.svg";
export { ForwardRef as ReactComponent };